interface options extends ScrollIntoViewOptions {
  noGlow?: boolean;
}
const scrollIntoMessage = (id: string, options?: options) => {
  const element = document.getElementById(id);
  if (element) {
    element?.scrollIntoView({
      ...options,
    });
    if (options?.noGlow) return;
    element.className = `${element?.className} glow`;
    setTimeout(() => {
      element.className = element.className.replace("glow", "");
    }, 1500);
  }
};

export default scrollIntoMessage;
